module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.17631/images/playlist-table.svg"